import React, { useEffect, useState } from "react";
import DiningRoom from "./DiningRoom";
import Spa from "./Spa";
import ConferenceRoomForm from "./ConferenceRoomForm";
import axiosInstance from "../../../api/axiosInstance";
import PageLoader from "../../loader/PageLoader";

const Menu = ({ onComplete }) => {
    const [currentOpt, setCurrentOpr] = useState(null);
    const [services, setServices] = useState([]);
    const hotelId = localStorage.getItem("hotelId");
    const [isPageLoading, setIsPageLoading] = useState(null);
    const [restaurantExists, setRestaurantExists] = useState(false); // Default to false

    useEffect(() => {
        const fetchServices = async () => {
            setIsPageLoading(true);
            try {
                const response = await axiosInstance.get(
                    `/api/v1/hotels/${hotelId}/services`,
                );
                const fetchedServicesData = response.data.data;
                setServices(fetchedServicesData);
                // console.log("Fetched Services:", fetchedServicesData);

                const hasInRoomDining = fetchedServicesData.some(
                    (service) => service.name === "In Room Dining",
                );

                // Fetch restaurant data
                const restaurantExistsData = await fetchRestaurantData();
                // console.log(
                //     "Restaurant data exist:",
                //     restaurantExistsData,
                //     hasInRoomDining,
                // );
                setRestaurantExists(restaurantExistsData);

                // Only show In Room Dining if both conditions are met
                if (hasInRoomDining && restaurantExistsData) {
                    setCurrentOpr("dining-room");
                } else if (
                    fetchedServicesData.some(
                        (service) => service.name === "Conference Room",
                    )
                ) {
                    setCurrentOpr("conference-room");
                } else if (
                    fetchedServicesData.some(
                        (service) => service.name === "Spa",
                    )
                ) {
                    setCurrentOpr("spa");
                } else {
                    // Call onComplete if none of the specific services exist
                    onComplete();
                }
            } catch (error) {
                console.error("Error fetching services:", error);
                onComplete(); // Optionally call onComplete in case of error
            } finally {
                setIsPageLoading(false);
            }
        };

        const fetchRestaurantData = async () => {
            try {
                const response = await axiosInstance.get(
                    `/api/v1/hotels/${hotelId}/restaurant`,
                );

                if (
                    response.data &&
                    response.data.id &&
                    response.data.name &&
                    response.data.manager
                ) {
                    // console.log("Restaurant data:", response.data);
                    return true; // Restaurant data exists
                } else {
                    return false; // Restaurant data does not exist
                }
            } catch (error) {
                console.error("Failed to fetch restaurant data:", error);
                return false; // Restaurant data does not exist in case of error
            }
        };

        fetchServices();
    }, [hotelId, onComplete]);

    const hasService = (serviceName) => {
        return services.some((service) => service.name === serviceName);
    };

    // Component mapping based on service name
    const componentMap = {
        "dining-room": <DiningRoom />,
        "conference-room": <ConferenceRoomForm />,
        spa: <Spa />,
    };

    // console.log("Current Option:", currentOpt);

    return (
        <>
            {isPageLoading && <PageLoader />}
            <div className="flex">
                <div className="w-[25%] border-r-[1.5px] flex flex-col gap-3">
                    {hasService("In Room Dining") && restaurantExists && (
                        <div
                            className={`border-b-[1.5px] cursor-pointer pb-2 ${
                                currentOpt === "dining-room"
                                    ? "text-[#ff7478]"
                                    : ""
                            }`}
                            onClick={() => setCurrentOpr("dining-room")}
                        >
                            <p className="font-semibold">IN ROOM DINING</p>
                            <small>Add In-Room Dining Menu</small>
                        </div>
                    )}
                    {hasService("Conference Room") && (
                        <div
                            className={`border-b-[1.5px] cursor-pointer pb-2 ${
                                currentOpt === "conference-room"
                                    ? "text-[#ff7478]"
                                    : ""
                            }`}
                            onClick={() => setCurrentOpr("conference-room")}
                        >
                            <p className="font-semibold">CONFERENCE ROOMS</p>
                            <small>Add Conference Room Packages</small>
                        </div>
                    )}
                    {hasService("Spa") && (
                        <div
                            className={`cursor-pointer pb-2 ${
                                currentOpt === "spa" ? "text-[#ff7478]" : ""
                            }`}
                            onClick={() => setCurrentOpr("spa")}
                        >
                            <p className="font-semibold">SPA</p>
                            <small>Add Spa Packages</small>
                        </div>
                    )}
                </div>

                <div className="w-[75%] flex flex-wrap justify-between">
                    {componentMap[currentOpt]}
                </div>
            </div>
            <button
                className="mt-6 px-4 py-2 bg-[#0B22B2] text-white rounded-md absolute bottom-3 left-[19%]"
                onClick={() => onComplete()}
            >
                Next
            </button>
        </>
    );
};

export default Menu;
